import { Stack } from "@mui/material";
import { ChallengesSection } from "Components/Loyalty/Shared/Challenges/ChallengesSection";
import { TeslaBanner } from "Components/Loyalty/Valor/TeslaBanner";
import type { LoyaltyTabId } from "Components/Loyalty/Shared/Tabs/config";
import { Tabs, type TabItem } from "Components/Loyalty/Shared/Tabs/Tabs";
import { LeaderboardSection } from "Components/Loyalty/Valor/LeaderboardSection";
import { RewardsSection } from "Components/Loyalty/Valor/RewardsSection";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Loyalty.Tabs;

type Props = {
  initialTab: LoyaltyTabId | null;
  onTabChange: (activeTab: LoyaltyTabId) => void;
};

export const ValorTabs = ({ initialTab, onTabChange }: Props) => {
  const { t } = useResource();

  const tabs: Array<TabItem> = [
    {
      id: "challenges",
      label: t(RESOURCES.Challenges),
      content: (
        <Stack gap={8}>
          <TeslaBanner />
          <ChallengesSection />
        </Stack>
      ),
    },
    {
      id: "leaderboard",
      label: t(RESOURCES.Leaderboard),
      content: <LeaderboardSection />,
    },
    {
      id: "rewards",
      label: t(RESOURCES.Rewards),
      content: <RewardsSection />,
    },
  ];

  return <Tabs initialTab={initialTab} onTabChange={onTabChange} tabs={tabs} />;
};
